import { render, staticRenderFns } from "./create-fixed-price-pack.vue?vue&type=template&id=19dcf855&scoped=true"
import script from "./create-fixed-price-pack.vue?vue&type=script&lang=js"
export * from "./create-fixed-price-pack.vue?vue&type=script&lang=js"
import style0 from "./create-fixed-price-pack.vue?vue&type=style&index=0&id=19dcf855&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.11.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "19dcf855",
  null
  
)

export default component.exports